
































import { ProductionPlanServiceProxy} from '@/service-proxies/app-v2/coproduction.service-proxies'
import Vue from 'vue'

const productionPlanServiceProxy = new ProductionPlanServiceProxy()
export default Vue.extend({
  components: {
  },
  data() {
    return {
      title: this.isCompletePlan ? this.$t('page_plan_complete_plan') : this.$t('page_plan_close_plan'),
      columns: [
      {
        title: this.$t('page_plan_craft_sort'),
        dataIndex: 'sort',
        key: 'sort',
        ellipsis: true,
        width: 171
      },
      {
        title: this.$t('page_product_process_name'),
        dataIndex: 'processName',
        key: 'processName',
        ellipsis: true,
        width: 171
      },
      {
        title: this.$t('page_job_process_num'),
        dataIndex: 'processSequence',
        key: 'processSequence',
        ellipsis: true,
        width: 171
      },
      {
        title: this.$t('page_product_process_no'),
        dataIndex: 'processCode',
        key: 'processCode',
        ellipsis: true,
        width: 171
      },
      {
        title: this.$t('page_plan_tou_liao_num'),
        dataIndex: 'inputNum',
        key: 'inputNum',
        ellipsis: true,
        width: 171
      },
      {
        title: this.$t('page_plan_qualified_number'),
        dataIndex: 'qualifyNum',
        key: 'qualifyNum',
        ellipsis: true,
      },
      {
        title: this.$t('page_plan_scrap_number'),
        dataIndex: 'scrappedNum',
        key: 'scrappedNum',
        ellipsis: true,
      },
      {
        title: this.$t('page_plan_processed_num'),
        dataIndex: 'surplusNum',
        key: 'surplusNum',
        ellipsis: true,
      },
     ],
     data: [],
     loading: false,
     tip: this.$t('page_plan_close_tip')
    }
  },
  created () {
    this.loading = true
    productionPlanServiceProxy.incompleteList(this.planId).then(res => {
      this.loading = false
      this.data = res.incompleteProcessDTOS
      this.getTip(res.surplusNum)
    })
  },
  computed: {

  },
  props: {
    isCompletePlan: {
      type: Boolean,
      default: false
    },
    planId: {
      type: String,
      default: ''
    }
  },
  watch: {

  },

  methods: {
    handleCancel() {
      this.$emit('closeCompleteModal')
    },
    handleOk() {
      if (this.isCompletePlan) {
        productionPlanServiceProxy.completePlan(this.planId).then(res => {
          this.$emit('closeCompleteModal', true)
        })
      } else {
        productionPlanServiceProxy.closePlan(this.planId).then(res => {
          this.$emit('closeCompleteModal', true)
        })
      }
    },
    getTip (num) {
      if (this.isCompletePlan) {
        this.tip = this.$t('page_plan_complete_tip')
        this.tip = this.tip.replace('{0}', num)
      }
    }
  }
})
